/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import { ColumnRange } from './columnRange.js';

/**
 * Represents a column range in a single line.
*/
export class RangeSingleLine {

	constructor(
		/** 1-based */
		public readonly lineNumber: number,
		public readonly columnRange: ColumnRange,
	) { }
}
